// Places a context menu at the trigger point, flipping/clamping so it never overflows the visual
// viewport (what jquery.ui.position did for the old plugin). CSS owns position:absolute/z-index;
// this only sets the dynamic left/top per open.

export function placeMenu(list: HTMLElement, x: number, y: number): void {
  list.style.left = `${x}px`;
  list.style.top = `${y}px`;

  const viewportWidth = window.visualViewport?.width ?? window.innerWidth;
  const viewportHeight = window.visualViewport?.height ?? window.innerHeight;
  const rect = list.getBoundingClientRect();

  const left = rect.right > viewportWidth ? Math.max(0, viewportWidth - rect.width) : x;
  const top = rect.bottom > viewportHeight ? Math.max(0, viewportHeight - rect.height) : y;

  list.style.left = `${left}px`;
  list.style.top = `${top}px`;
}
